export const blockIconsTravelLocalDiningNew = (
	<span className='material-symbols-outlined'>local_dining</span>
);
